/* eslint-disable camelcase, max-statements */

export const MONTHS = [
  {'key': 'ene', 'label': 'ENE'},
  {'key': 'feb', 'label': 'FEB'},
  {'key': 'mar', 'label': 'MAR'},
  {'key': 'abr', 'label': 'ABR'},
  {'key': 'may', 'label': 'MAY'},
  {'key': 'jun', 'label': 'JUN'},
  {'key': 'jul', 'label': 'JUL'},
  {'key': 'ago', 'label': 'AGO'},
  {'key': 'sep', 'label': 'SEP'},
  {'key': 'oct', 'label': 'OCT'},
  {'key': 'nov', 'label': 'NOV'},
  {'key': 'dic', 'label': 'DIC'},
];

export const REAL_YEAR = new Date().getFullYear();

export const SERVICE_TYPES = [
  {'id': 1, 'label': 'Casos de diagnóstico'},
  {'id': 2, 'label': 'Mantenimiento'},
  {'id': 3, 'label': 'Reparaciones generales'},
];

export const emptyMonths = () => MONTHS.reduce((acc, m) => ({...acc, [m.key]: 0}), {});

export const monthTotal = (row) => MONTHS.reduce((s, m) => s + (parseInt(row[m.key], 10) || 0), 0);

export const checkEditable = (monthKey, year) => {
  const mIndex = MONTHS.findIndex((m) => m.key === monthKey);
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();
  const currentDay = now.getDate();
  let cutoffYear = currentYear;
  let cutoffMonth = currentMonth;

  if (currentDay <= 10) {
    cutoffMonth -= 1;
    if (cutoffMonth < 0) {
      cutoffMonth = 11;
      cutoffYear -= 1;
    }
  }
  if (year < cutoffYear) {
    return false;
  }
  if ((year === cutoffYear) && (mIndex < cutoffMonth)) {
    return false;
  }
  return true;
};

export const getProcessedRecords = (data, filters, colFilters, sortConfig) => {
  if (!filters.consecionario || !filters.agencia || !filters.year) {
    return [];
  }
  let result = SERVICE_TYPES.map((st) => {
    const existing = data.find((r) =>
      (r.anio === filters.year) &&
      (String(r.consecionario) === String(filters.consecionario)) &&
      (String(r.agencia) === String(filters.agencia)) &&
      (Number(r.id_tipo_trabajo) === st.id)
    );
    return existing || {'id': null, 'id_tipo_trabajo': st.id, ...emptyMonths()};
  });

  Object.keys(colFilters).forEach((key) => {
    const q = (colFilters[key] || '').toLowerCase();
    if (q) {
      result = result.filter((r) => {
        if (key === 'id_tipo_trabajo') {
          const sLabel = SERVICE_TYPES.find((s) => s.id === r[key])?.label || '';
          return sLabel.toLowerCase().includes(q);
        }
        return String(r[key] || '').toLowerCase().includes(q);
      });
    }
  });

  if (sortConfig.key) {
    result.sort((a, b) => {
      const vA = a[sortConfig.key] || '';
      const vB = b[sortConfig.key] || '';
      const nA = Number(vA);
      const nB = Number(vB);
      if (!isNaN(nA) && !isNaN(nB)) {
        return (sortConfig.dir === 'asc') ? (nA - nB) : (nB - nA);
      }
      const sA = String(vA).toLowerCase();
      const sB = String(vB).toLowerCase();
      if (sA < sB) {
        return (sortConfig.dir === 'asc') ? -1 : 1;
      }
      if (sA > sB) {
        return (sortConfig.dir === 'asc') ? 1 : -1;
      }
      return 0;
    });
  }
  return result;
};

export const styles = `
  .wma-root {
    --c-celeste: #58B8E6;
    --c-celeste-header: #58B8E6;
    --c-text: #1a1a2e;
    --c-muted: #6b7280;
    --c-green: #23b563;
    background: #f2f7fb;
    min-height: 100vh;
  }
  .wma-root .ui.dropdown,
  .wma-root .ui.selection.dropdown,
  .wma-root .ui.selection.active.dropdown {
    border: 1px solid rgba(34, 36, 38, 0.15) !important; background-color: #fff !important;
    color: var(--c-text) !important; box-shadow: none !important;
  }
  .wma-root .ui.selection.dropdown:hover,
  .wma-root .ui.selection.dropdown:focus { border: 1px solid var(--c-celeste) !important; }
  .wma-root .ui.dropdown > .text { color: var(--c-text) !important; }
  .wma-root .ui.dropdown .icon,
  .wma-root .ui.dropdown > .icon { color: var(--c-muted) !important; }
  .wma-root .ui.dropdown .menu .item { color: var(--c-text) !important; }
  .wma-root .ui.dropdown .menu { z-index: 9999 !important; }
  .wma-title-bar { background: #1a1a2e; border-radius: 12px 12px 0 0; padding: 22px 28px 18px; }
  .wma-title { font-size: 1.25rem; font-weight: 700; color: #fff; }
  .wma-area-label {
    font-size: 0.72rem; font-weight: 600; color: rgba(255,255,255,0.5);
    text-transform: uppercase; margin-bottom: 5px;
  }
  .wma-content-card { border-radius: 0 0 12px 12px; padding: 22px 24px; background: #fff; }
  .wma-toolbar { display: flex; flex-direction: column; gap: 16px; margin-bottom: 20px; }
  .wma-toolbar-bottom { width: 100%; }
  .wma-year-nav-wrap { display: flex; align-items: center; gap: 8px; width: 100%; }
  .wma-year-nav-btn {
    border: none; background: #e4eef5; border-radius: 6px; cursor: pointer;
    padding: 8px 12px; font-weight: bold; color: #6b7280;
  }
  .wma-year-nav-btn:hover { background: #d4edf8; }
  .wma-year-tabs {
    display: flex; gap: 3px; background: #e4eef5; border-radius: 8px; padding: 3px;
    overflow-x: auto; width: 100%; scroll-behavior: smooth;
  }
  .wma-year-tabs::-webkit-scrollbar { height: 6px; }
  .wma-year-tabs::-webkit-scrollbar-thumb { background: #b8d9ec; border-radius: 4px; }
  .wma-year-tab {
    flex: 1; padding: 8px 12px; border-radius: 6px; font-size: 0.85rem; font-weight: 600;
    cursor: pointer; border: none; background: transparent; color: var(--c-muted);
    display: flex; align-items: center; justify-content: center; gap: 6px; white-space: nowrap;
    transition: background 0.2s;
  }
  .wma-year-tab:hover { background: rgba(88, 184, 230, 0.15); }
  .wma-year-tab.active { background: var(--c-celeste); color: #fff; }
  .wma-table-wrap {
    overflow-x: auto; border-radius: 10px; border: 2px solid var(--c-celeste);
    margin-bottom: 20px;
  }
  .wma-table { width: 100%; border-collapse: collapse; font-size: 0.81rem; }
  .wma-table thead tr.header-row th {
    background: var(--c-celeste-header); color: #fff; padding: 9px 10px;
    text-transform: uppercase; font-size: 0.7rem; border-right: 1px solid rgba(255,255,255,0.2);
    white-space: nowrap;
  }
  .wma-sort-btn {
    background: transparent; border: none; cursor: pointer; color: rgba(255,255,255,0.4);
    padding: 0 4px; font-size: 0.75rem; transition: color 0.2s;
  }
  .wma-sort-btn:hover { color: rgba(255,255,255,0.8); }
  .wma-sort-btn.active { color: #fff; }
  .wma-filter-input {
    width: 100%; min-width: 60px; border: 1px solid #b8d9ec; border-radius: 4px;
    padding: 4px; font-size: 0.75rem; outline: none; color: var(--c-text);
  }
  .wma-filter-input:focus { border-color: var(--c-celeste); box-shadow: 0 0 0 1px var(--c-celeste); }
  .wma-month-input {
    width: 54px; text-align: center; border: 1.5px solid #eef5fb; border-radius: 5px;
    padding: 4px 3px; font-size: 0.8rem; background: #eef5fb; outline: none;
  }
  .wma-month-input:disabled { background: #e0e0e0; cursor: not-allowed; opacity: 0.7; }
  .wma-month-text {
    display: inline-block; width: 54px; text-align: center; padding: 4px 3px;
    font-size: 0.8rem; cursor: pointer; border: 1.5px solid transparent; border-radius: 5px;
    transition: background 0.2s;
  }
  .wma-month-text:hover { background: rgba(88, 184, 230, 0.1); border-color: #b8d9ec; }
  .wma-action-btn {
    border: none; background: none; cursor: pointer; font-size: 1.1rem; padding: 2px 5px;
    display: inline-flex; align-items: center; justify-content: center; transition: transform 0.1s;
  }
  .wma-action-btn:hover { transform: scale(1.1); }
  .wma-action-btn:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }
  .wma-star { color: #f1c40f; font-size: 1rem; }
  .wma-table tbody tr:hover td { background: #f0f8fd; }
  .sticky-col {
    position: sticky; right: 0; background: #fff;
    box-shadow: -3px 0 6px rgba(0,0,0,0.05); z-index: 1; text-align: center;
  }
  .wma-table thead tr.header-row th.sticky-col { background: var(--c-celeste-header); z-index: 2; }
  .wma-table thead tr th.sticky-col { z-index: 2; }
  .wma-table tbody tr:hover td.sticky-col { background: #f0f8fd; }
  .wma-label { display: block; font-weight: 700; font-size: 1.2rem; margin-bottom: 8px; color: #1a1a2e; }
  .wma-chart-container {
    margin-top: 25px; border: 2px solid var(--c-celeste); border-radius: 10px;
    padding: 20px; background: #fafdfd;
  }
`;
